<template>
  <v-layout>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title>{{ getDialogTitle }}</v-card-title>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="tipoAsistencia.nombre"
                  label="Nombre"
                  placeholder="Tipo de Asistencia..."
                  :rules="nombreRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="d-fex justify-center pt-3">
                <v-switch
                  v-model="tipoAsistencia.estado"
                  inset
                  class="pt-0 mt-2"
                  color="primary"
                  label="Estado"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 pb-4">
            <v-btn color="primary" outlined @click="clear">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="tipoAsistencias"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Listado de Tipos de Asistencias</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md6 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex
                xs12
                sm12
                md2
                class="text-center pt-3 mr-2"
                align-self-center
              >
                <v-btn color="blue" dark block @click="dialog = true">
                  Agregar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="detalles(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
  
  <script>
import axios from "axios";

export default {
  data: () => ({
    valid: true,
    tipoAsistencia: {
      id_tipo_asistencia: null,
      nombre: "",
      estado: false,
    },
    nombreRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => (v && v.length <= 50) || "Nombre debe ser menor a 50 caracteres",
    ],
    loader: false,
    editing: false,
    search: "",
    headers: [
      { text: "ID", value: "id_tipo_asistencia", align: "center", width: 100 },
      { text: "Tipo Asistencia", value: "nombre", align: "center" },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Editar", value: "editar", align: "center", width: 100 },
    ],
    tipoAsistencias: [],
    dialog: false,
  }),
  created() {
    this.listar();
  },
  computed: {
    getDialogTitle() {
      return this.tipoAsistencia.tipoAsistenciaId == null
        ? "Nuevo Tipo Asistencia"
        : "Editar Tipo Asistencia";
    },
  },
  methods: {
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias", configuracion)
        .then((res) => (this.tipoAsistencias = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    guardar() {
      if (this.$refs.form.validate()) {
        if (this.tipoAsistencia.id_tipo_asistencia == null) {
          this.nuevo();
        } else {
          this.actualizar();
        }
      }
    },
    nuevo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/TipoAsistencias",
          {
            nombre: this.tipoAsistencia.nombre,
            estado: this.tipoAsistencia.estado,
          },
          configuracion
        )
        .then((res) => {
          this.listar();
          this.clear();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    actualizar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/TipoAsistencias/${this.tipoAsistencia.id_tipo_asistencia}`,
          {
            Nombre: this.tipoAsistencia.nombre,
            Estado: this.tipoAsistencia.estado,
          },
          configuracion
        )
        .then(() => {
          this.listar();
          this.clear();
        })
        .catch((err) => console.error(err));
    },
    detalles(item) {
      this.dialog = true;
      this.tipoAsistencia = { ...item };
    },
    clear() {
      this.dialog = false;
      this.$refs.form.resetValidation();
      this.tipoAsistencia = {
        id_tipo_asistencia: null,
        nombre: "",
        estado: false,
      };
    },
  },
};
</script>